import React from 'react';

import './Hotspot.scss'
import Icon from '../../partials/Icons'

const Hotspot = ({
  coordinates: [top, left, width, height],
  onClick,
  seen,
  index,
  correct
}) => {
  let className = 'Hotspot';
  let Hotspot_yn = 0;
  if (seen) {
    className += ' seen';
  }
  if (correct === true) {
    className += ' correct';
    Hotspot_yn = 1;
  } else if (correct === false) {
    className += ' incorrect';
    Hotspot_yn = 2;
  }
  return (
    <div className={className} onClick={onClick} style={{
      top: `${top}%`,
      left: `${left}%`,
      width: `${width}%`,
      height: `${height}%`
    }}>
      <div className="index">
        <div className="number">{index + 1}</div>
      </div>
      <div className="pos_icon">
        { Hotspot_yn > 0 ? <Icon name={correct ? 'check' : 'incorrect' } /> : false }
      </div>
    </div>
  );
};

export default Hotspot;
